import { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSessionRestore } from '../modules/login/useSessionRestore'
import { sessionStore } from '../sharedStores/sessionStore'

/**
 * Component that protects routes requiring authentication
 * Redirects to login if the user is not authenticated
 */
export const ProtectedRoute = () => {
	const { isLoggedIn } = sessionStore()
	const location = useLocation()
	const { isRestoring } = useSessionRestore()

	useEffect(() => {
		if (!isLoggedIn) {
			sessionStore.setState({ redirectPath: location.pathname })
		}
	}, [isLoggedIn, location.pathname])

	// Wait for session restoration to complete before redirecting
	if (isRestoring) {
		return null
	}

	if (!isLoggedIn) {
		return <Navigate to='/auth/login' replace />
	}

	return <Outlet />
}
